import React, { memo } from 'react';

import { Filter, NameField, NumberField } from 'components';

const AisVersionFilter = memo(() => {
  return (
    <Filter
      initialValues={{
        name: '',
        number: '',
      }}
      mainField={<NumberField />}
    >
      <NumberField />
      <NameField />
    </Filter>
  );
});

export default AisVersionFilter;
